import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import CKEDITOR from '@workboard/ckeditor5-build-wobo';

interface ICKEditorComponentProps {
  data: string,
  onChange: (data: string) => void,
  editorConfiguration: object
}

const CKEditorComponent = ({ data = '', onChange, editorConfiguration }: ICKEditorComponentProps) => {
  const [editorData, setEditorData] = React.useState<string>(data);
  const handleReady = (editor) => {
    editor.editing.view.change((writer) => {
      writer.setStyle({
        'min-height': '250px',
        border: 'none',
        'padding-top': '0.6em'
      }, editor.editing.view.document.getRoot());
    });
    editor.editing.view.focus();
  };

  const handleChange = (_, editor) => {
    const _editorData = editor.getData();
    setEditorData(_editorData);
    onChange(_editorData);
  };

  return (
    <CKEditor
      editor={CKEDITOR.ClassicEditor}
      config={{
        licenseKey: ckeditorLicenseKey,
        ...editorConfiguration,
      }}
      onChange={handleChange}
      onReady={handleReady}
      data={editorData}
    />
  );
}

export default CKEditorComponent;
